import React from 'react';

import type { CliveButtonProps } from '../CliveButton/CliveButton';
import CliveButton from '../CliveButton/CliveButton';

const CliveRecommendationPanelButton: React.FC<CliveButtonProps> = ({ onClick, ...otherProps }) => {
  const [isLoading, setIsLoading] = React.useState(false);
  const handleClick = async (event: React.MouseEvent<HTMLButtonElement>) => {
    // we stop propagation to prevent the panel from collapsing/expanding when the button is clicked
    event.stopPropagation();
    if (onClick) {
      setIsLoading(true);
      try {
        await onClick(event);
      } finally {
        setIsLoading(false);
      }
    }
  };

  return <CliveButton {...otherProps} onClick={handleClick} disabled={isLoading || otherProps.disabled} />;
};

export default CliveRecommendationPanelButton;
